import React, { useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import { useModal } from "../../contexts"; // Adjust path if necessary

const Modaal1 = () => {
    const { modalState, hideModal } = useModal();

    const {
        show,
        title,
        bodyContent,
        bodyContent1,
        footer,
        size,
        centered,
        className,
        backdrop,
        autoClose,
    } = modalState;

    useEffect(() => {
        let timer;
        if (show && autoClose) {
            timer = setTimeout(() => {
                hideModal();
            }, autoClose);
        }
        return () => {
            if (timer) clearTimeout(timer); 
        };
    }, [show, autoClose, hideModal]);

    return (
        <Modal
            show={show}
            onHide={hideModal}
            size={size}
            aria-labelledby="contained-modal-title-vcenter"
            centered={centered}
            className={className}
            backdrop={backdrop}
        >
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">
                    {title}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {bodyContent}
                {bodyContent1}
            </Modal.Body>
            <Modal.Footer>{footer}</Modal.Footer>
        </Modal> 
        

        
    );
};

export default Modaal1;
